import styled from "styled-components";

export const EdtBranchStyles = styled.section`
  min-height: calc(100vh - 42px);

  form {
    margin-top: 24px;
  }
`;
